'use client';
/** @jsxImportSource @emotion/react */

import type { TableCellProps } from '@mui/material/TableCell';

import MuiTableCell from '@mui/material/TableCell';

// type ExcludedMuiProps = 'children';

// interface TableCellProps extends Omit<TableCellBaseProps, ExcludedMuiProps> {
//   component?: React.ElementType;
// }

export type { TableCellProps };
export const TableCell: React.FC<TableCellProps> = MuiTableCell;

TableCell.displayName = 'TableCell';
